<mat-form-field style="width: 100%">
  <mat-label>Select Project</mat-label>
  <input
    #input
    type="text"
    placeholder="Choose a Project"
    matInput
    [class.invalid]="invalid()"
    [disabled]="disabled()"
    [readonly]="readonly()"
    [matAutocomplete]="projectAuto"
    (blur)="touched.set(true)"
    [value]="value() ? $safeNavigationMigration(getProject?.value()?.project?.projectNumber) : value()"
    (input)="inputValue.set($event.target.value)"
  />
  <mat-autocomplete
    requireSelection
    #projectAuto="matAutocomplete"
    [displayWith]="displayFn"
    (optionSelected)="value.set($event.option.value.id)"
  >
    @for (option of filteredOptions.data()?.projects; track option.id) {
      <mat-option [value]="option">{{ option.projectNumber }}</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
@if (invalid()) {
  <div
    class="error-messages"
    role="alert"
  >
    @for (error of errors(); track error) {
      <span class="error">{{ error.message }}</span>
    }
  </div>
}
@if (disabled() && disabledReasons().length > 0) {
  <div class="disabled-reasons">
    @for (reason of disabledReasons(); track reason) {
      <span>{{ reason.message }}</span>
    }
  </div>
}
<!-- <code>Model Value: {{ value() }}</code> -->
